import appConstants from '../../../../../../../../../constants';
import { KEYS } from '../../../../../../../../../l18n/constants';
import computeClassName from '../../../../../../../../../utils/computeClassName';
import { useL18nContext } from '../../../../../../../ContextProvider/L18n';
import { usePartnerSearchContext } from '../../../../../../../ContextProvider/Partner/Search';
import CCFormDropdown from '../../../../../../../../libs/CiscoCore/Form/Dropdown';

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});

export default function SortingParameter({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const {
    isSortingParameterDropdownOpened,
    sortingParameterValues,
    selectSortingParameterValue,
    toggleSortingParameterDropdown,

    selectedCountry,
    isFilterLoadingInProgress,
    isPartnerSearchInProgress,
  } = usePartnerSearchContext();

  return (
    <CCFormDropdown isDisabled={isFilterLoadingInProgress || isPartnerSearchInProgress || !selectedCountry}
                    hasError={false}
                    isProcessingInProgress={false}
                    isOpened={isSortingParameterDropdownOpened}
                    openFn={toggleSortingParameterDropdown}
                    closeFn={toggleSortingParameterDropdown}
                    size="xsmall"
                    optionList={sortingParameterValues.map((sortingOption) => { return {...sortingOption, [appConstants.KEY_NAME]:getTranslationFor(sortingOption[appConstants.KEY_NAME]) }})}
                    optionKeyIsDisabled={appConstants.KEY_IS_DISABLED}
                    optionKeyIsSelected={appConstants.KEY_IS_SELECTED}
                    optionKeyLabel={appConstants.KEY_NAME}
                    optionKeyValue={appConstants.KEY_CODE}
                    optionSelectFn={selectSortingParameterValue}
                    inline={false}
                    className={computedClassName}/>
  );
}
